/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Camera_Edit_VehicleInputs */

const vi_fleet_camera_edit_vehicle = /** @type {(inputs: Fleet_Camera_Edit_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa thông tin xe`)
};

/**

* @param {Fleet_Camera_Edit_VehicleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_camera_edit_vehicle = /** @type {((inputs?: Fleet_Camera_Edit_VehicleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Camera_Edit_VehicleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_camera_edit_vehicle(inputs)
});